import React, { Component } from 'react';
import { Spin, Row, Col, Table, DatePicker, List } from 'antd';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import { data_guest } from './data';
import "./index.scss"

const { MonthPicker } = DatePicker

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            loading: true,
            data: [],
            lastTen: [],
            topTen: [],
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
        this.setState({
            loading: false,
        })
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data_guest);
        let data = JSON.parse(dataBegin);
        let lastTen = [];
        let topTen = [];
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getguestrating?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {

            data = [{ ...x.data.table }];
            lastTen = x.data.lastTen || [];
            topTen = x.data.topTen || [];
            this.setState({
                data,
                lastTen,
                topTen,
                loading: false,
            })
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    render() {
        const { data, lastTen, topTen } = this.state;
        const columns = [{
            title: data[0] && data[0].hotel_name,
            children: [{
                title: <div>Current Month<br />本月</div>,
                key: 'mtd',
                dataIndex: 'mtd',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{record.mtd || "-"}</div>
                }
            }]
        }, {
            children: [{
                title: <div>Ranking<br />排序</div>,
                key: 'sort',
                dataIndex: 'sort',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{text || "NA"}</div>
                }
            }]
        }, {
            title: '',
            children: [{
                title: <div>Total No. of Review<br />评论数</div>,
                key: 'total',
                dataIndex: 'total',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{text || "-"}</div>
                }
            }]
        }, {
            title: '',
            children: [{
                title: <div>Cleanliness<br />洁净度</div>,
                key: 'cleanliness',
                dataIndex: 'cleanliness',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{text || "-"}</div>
                }
            }]
        }, {
            title: '',
            children: [{
                title: <div>Service<br />服务</div>,
                key: 'service',
                dataIndex: 'service',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{text || "-"}</div>
                }
            }]
        }, {
            title: '',
            children: [{
                title: <div>YTD<br />年累计</div>,
                key: 'ytd',
                dataIndex: 'ytd',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{text || "-"}</div>
                }
            }]
        }, {
            title: '',
            children: [{
                title: <div>Ranking<br />排序</div>,
                key: 'ytd_sort',
                dataIndex: 'ytd_sort',
                align: 'center',
                render: (text, record) => {
                    return <div className="table-guestrating">{text || "NA"}</div>
                }
            }]
        }]
        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 table-gust-rating">
                    <Row className="title" id="table4_1_1" style={{ width: this.state.print ? 2600 : 'auto' }}>
                        <Row>WynReview - Medallia 客人评分</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <Table
                                columns={columns}
                                dataSource={data}
                                size="middle"
                                id="table"
                                bordered
                                pagination={false}
                                className="content"
                                rowKey={(record, index) => record.hotel_name}
                            />
                            <div className="remarks">*月评论数达到30条为有效客评分数，可纳入集团排名；未达30条为无效。</div>
                            <div style={{ marginTop: 50 }}>
                                <div className="list-l">
                                    <div className="list-title">本月红榜<span className="list-title-s">（排名前十酒店 TOP 10）</span></div>
                                    <div className="p-l-r-24">
                                        {
                                            (topTen || []).map((item, i) => {
                                                return (
                                                    <div className="list-item">
                                                        <span className="list-item-no">{i + 1}</span>
                                                        <span>{item.hotel_name}</span>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="list-r">
                                    <div className="list-title"><span className="list-title-s">本月黑榜（排名后十名酒店 BOTTOM 10）</span></div>
                                    <div className="p-l-r-24">
                                        {
                                            (lastTen || []).map((item, i) => {
                                                return (
                                                    <div className="list-item">
                                                        <span className="list-item-no">{i + 1}</span>
                                                        <span>{item.hotel_name}</span>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Row>
                    <div className="footer-notes">
                        Notes：
                        <br />
                        1. 每月酒店客评总分基于该酒店在Medallia平台添加的所有渠道的月度总分overall score;
                        <br />
                        2. Total No. of Review是酒店在Medallia平台所有添加渠道的总点评数；
                        <br />
                        3. Cleanliness和Service的分数取自该酒店在携程上相应的月度分数（如酒店未添加携程渠道，则抓取TripAdvisor上相应的分值）；
                        <br />
                        4. YTD的评分取自Medallia平台抓取酒店所有添加渠道的当年度截止至今的总评分。
                    </div>
                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/guestRating/index.js